import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import ImageResponsive from '../../../contentful/ImageResponsive';

export default (props) => {
  function DisplayImage(props) {
    let imageSrc = 'https://dummyimage.com/200x100/CCCCCC/';
    if (props.image && props.image.url !== null) {
      imageSrc = props.image.url;
    }
    return (
      <ImageResponsive
        className="img-rounded"
        src={imageSrc}
        width={200}
        height={100}
        fit="pad"
      >
      </ImageResponsive>
    );
  }

  React.useEffect(() => {
    document.title = 'Admin - Merker';
  }, []);

  return (
    <div className="row">
      {props.makes.map((make) => {
        const logo = make.logoAdmin || make.logoStandalone || make.logo;

        let cls = 'thumbnail alert alert-warning';

        if (make.published) {
          if (make.updated) {
            cls = 'thumbnail alert alert-info';
          } else {
            cls = 'thumbnail alert alert-success';
          }
        } else if (make.archived) {
          cls = 'thumbnail alert alert-danger';
        }

        return (
          <div className="col-xs-6 col-md-3" key={make.id}>
            <div className={cls}>
              <Link to={`/merker/${make.id}`}>
                <h4><center>{make.name}</center></h4>
                <DisplayImage image={logo} />
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};
